import app from './app.json';
import common from './common.json';
import page from './page.json';
const heIL = {
    app,
    common,
    page
};
export default heIL;
